import { Dayjs } from 'dayjs'

import { Author, DateRange, Organisation } from '../common/dataStructures'

export interface Licence {
  name: string,
  url: string
}

export interface DoiVersion {
  title: string,
  doi: string
}

export interface Edmed {
  title: string,
  id: string
}

export interface DownloadLink {
  uri: string,
  type: string
}

export class BoundingBox {
  westCorner: number
  eastCorner: number
  northCorner: number
  southCorner: number

  constructor (westCorner: number, eastCorner: number, northCorner: number, southCorner: number) {
    this.westCorner = westCorner
    this.eastCorner = eastCorner
    this.northCorner = northCorner
    this.southCorner = southCorner
  }
}

export interface Citation {
  shortTitle: string,
  title: string,
  authors: Author[],
  authorOrganisations: Organisation[],
  contributors: Author[],
  contributorOrganisations: Organisation[],
  abstract: string,
  subjects: string[],
  temporalCoverage: DateRange,
  geolocations: BoundingBox[],
  licence: Licence | null,
  publicationDate: Dayjs,
  doi: string,
  publisher: string,
  isMostRecent: boolean,
  replaces: DoiVersion[],
  replacedBy: DoiVersion[],
  citation: string,
  edmed: Edmed,
  fileFormats: string[],
  spatialCoverage: string[],
  languages: string[],
  downloadLinks: DownloadLink[]
  endEmbargo: string,
}
